var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#CDD4E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2736 15.7907C16.1721 15.7583 15.5308 15.4766 15.9315 14.2895H15.9258C16.9704 13.241 17.7686 11.5539 17.7686 9.89288C17.7686 7.33888 16.026 6 14.0006 6C11.974 6 10.2409 7.33826 10.2409 9.89288C10.2409 11.5607 11.0347 13.2547 12.0857 14.3007C12.4954 15.3479 11.7628 15.7366 11.6097 15.7907C9.48861 16.5388 7 17.9013 7 19.2464V19.7507C7 21.5834 10.6461 22 14.0204 22C17.3998 22 21 21.5834 21 19.7507V19.2464C21 17.8609 18.4993 16.5089 16.2736 15.7907ZM12.7538 21.2065C12.7538 19.6214 13.7894 17.4815 13.7894 17.4815L13.0728 16.9337C13.0728 16.41 14 15.8622 14 15.8622C14 15.8622 14.9246 16.4188 14.9246 16.9337L14.2106 17.4815C14.2106 17.4815 15.2462 19.6133 15.2462 21.2239C15.2462 21.4764 12.7538 21.4179 12.7538 21.2065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessIcon);
export default __webpack_public_path__ + "static/media/BusinessIcon.32e8b8d4a01dd55b156bb42f24c6ef80.svg";
export { ForwardRef as ReactComponent };